/**
 * Збереження, чернетки й захист від втрати (UX-25, UX-26, UX-27; `ui/save`). Простір лінивих
 * чанків: у зведений `uk.ts` не входить (його тягне документ входу), перетин ключів перевіряє
 * `uk.test.ts`.
 */
export const save = {
  saveDraft: 'Чернетка',
  saveDraftTitle: 'Введене збережено в цій вкладці, доки ви не збережете форму',
  saveSaving: 'Зберігається…',
  saveSaved: 'Збережено',
  saveNotSaved: 'Не збережено',
  saveRetry: 'Ще раз',
  /** Тост першого переходу з чернеткою за сесію (UX-27). */
  saveDraftKept: 'Чернетку збережено — вона повернеться, коли ви знову відкриєте форму',
  draftPromptTitle: 'Продовжити запис?',
  draftPromptContinue: 'Продовжити',
  draftPromptDiscard: 'Відкинути',
  draftPromptSaved: (time: string) => `Чернетка від ${time}`,
  draftPromptStale: 'Чернетка може бути застарілою: запис змінено після неї',
  draftPromptStaleAt: (time: string) =>
    `Чернетка може бути застарілою: запис змінено ${time}, після неї`,
  unsavedTitle: 'Є незбережені зміни',
  unsavedText: 'Якщо піти зараз, зміни буде втрачено.',
  unsavedSave: 'Зберегти',
  unsavedDiscard: 'Не зберігати',
  unsavedStay: 'Залишитися',
  /** Діалог «Вийти» при незбережених змінах без чернетки (platform/sign-out.ts). */
  signOutUnsavedText: 'Вийти без збереження? Зміни буде втрачено.',
  signOutUnsavedCancel: 'Скасувати',
  signOutUnsavedConfirm: 'Вийти',
} as const;
